// Generated by scripts/build-achievement-assets.cjs
export default {
  "favorite.png": "heart.webp",
  "1-lvl.png": "1-lvl.webp",
  "100-varieties.png": "100-varieties.webp",
  "2-lvl.png": "2-lvl.webp",
  "27d31431-73a6-4d46-bd16-4650b92e46b5.svg": "27d31431-73a6-4d46-bd16-4650b92e46b5.webp",
  "3-lvl.png": "3-lvl.webp",
  "30-varieties.png": "30-varieties.webp",
  "3738c026-3720-4744-ba16-ddcda899c8f5.svg": "3738c026-3720-4744-ba16-ddcda899c8f5.webp",
  "4-lvl.png": "4-lvl.webp",
  "5-lvl.png": "5-lvl.webp",
  "6-lvl.png": "6-lvl.webp",
  "author.png": "author.webp",
  "calendar.png": "calendar.webp",
  "confession.png": "confession.webp",
  "count.png": "count.webp",
  "expert.png": "expert.webp",
  "feeder.png": "feeder.webp",
  "first-in-garden.png": "first-in-garden.webp",
  "first-plant.png": "first-plant.webp",
  "first.png": "first.webp",
  "fixed.png": "fixed.webp",
  "garden-label.png": "garden-label.webp",
  "grown-fruit.png": "grown-fruit.webp",
  "heart.png": "heart.webp",
  "mr-pepper.png": "mr-pepper.webp",
  "mr-tomato.png": "mr-tomato.webp",
  "mystery-shopper.png": "mystery-shopper.webp",
  "new-card.png": "new-card.webp",
  "new-garden.png": "new-garden.webp",
  "note.png": "note.webp",
  "old-timer.png": "old-timer.webp",
  "opinion-leader.png": "opinion-leader.webp",
  "photo.png": "photo.webp",
  "photomaster.png": "photomaster.webp",
  "printer.png": "printer.webp",
  "qa-first-help.svg": "qa-first-help.webp",
  "qa-first-responder.svg": "qa-first-responder.webp",
  "qa-mentor.svg": "qa-mentor.webp",
  "qa-neighbor.svg": "qa-neighbor.webp",
  "record-holder.png": "record-holder.webp",
  "repeat.png": "repeat.webp",
  "second-line.png": "second-line.webp",
  "twins.png": "twins.webp",
  "welcome-garden.png": "welcome-garden.webp",
  "when.png": "when.webp",
  "where.png": "where.webp",
  "who.png": "who.webp",
  "wings-gold.png": "wings-gold.webp",
  "wings-lvl-bronze.png": "wings-lvl-bronze.webp",
  "wings-lvl-gold.png": "wings-lvl-gold.webp",
  "wings-lvl-silver.png": "wings-lvl-silver.webp",
  "wings.png": "wings.webp"
};
